<mat-form-field class="ignite-name-field" [attr.id]="id" appearance="outline" [hideRequiredMarker]="true" [class.is-empty]="isEmpty()">
  <input #inputControl [class.hidden]="hasNoName" matInput [formControl]="nameControl" required maxlength="50" trim="blur" />
  @if (label !== '') {
    <mat-label floatLabel>{{ label }}</mat-label>
  } 
  @if (showCheckbox && hint !== '' && !hasNoName) {
    <mat-hint>{{ hint }}</mat-hint>
  } 
  @if (nameControl.hasError('required')) {
    <mat-error id="name_error_required" i18n
      >Enter all {{ isSurname ? "surnames or last names," : "given names" }} as shown on
      {{ enterOnBehalfOf === "Myself" ? "your" : enterOnBehalfOf + "'s" }} ID
    </mat-error>
  } 
  @if (nameControl.hasError('invalidChars')) {
    <mat-error id="name_error_pattern" i18n>{{ label }} contains invalid characters</mat-error>
  } 
  @if (nameControl.hasError('doesNotStartWithALetter')) {
    <mat-error id="name_error_does_not_start_with_letter" i18n>{{ label }} must start with a letter</mat-error>
  } 
  @if (nameControl.hasError('mustHaveName')) {
    <mat-error id="name_error_must_have_name" i18n>Either a surname or given names must be provided</mat-error>
  }
</mat-form-field>

<div [class.hidden]="!showCheckbox" #noName class="no-name-wrapper">
  <mat-checkbox [(ngModel)]="hasNoName" (change)="onNoNameChanged($event)">
    {{ enterOnBehalfOf === "Myself" ? "I do" : enterOnBehalfOf + " does" }} not have {{ isSurname ? "a surname" : "any given names" }} on
    {{ enterOnBehalfOf === "Myself" ? "my" : "their" }} passport/ID
  </mat-checkbox>
</div>
